module.exports = __webpack_public_path__ + "static/media/stationFix.53268d8f.svg";